import ChapterListActions from 'routes/ChapterList/ChapterListActions/ChapterListActions';

export default ChapterListActions;
